export default {
  MOBILE: {
    MIN: "0px",
    MAX: "767px"
  },
  TABLET: {
    MIN: "768px",
    MAX: "1023px"
  },
  LAPTOP: {
    MIN: "1024px",
    MAX: "1223px"
  },
  DESKTOP: {
    MIN: "1224px"
  }
}
